<template>
  <div>
      <h2 class="mb-6 text-center" id="shipping-method-heading">- {{ $t("shop.choose-shipping-method") }} -</h2>


    <div class="mb-2" v-if="allowMultipleShipping()">
      {{ $t("shop.multiple-items-in-cart") }}
    </div>

    <div
      v-for="(shippingItem, index) in shippingItems"
      :key="'shippingItem' + index"
      class="w-full bg-gray-200 rounded py-6 px-6 mb-2"
    >
      <div class=""  v-if="allowMultipleShipping()">{{ shippingItem.sku.name }}</div>
      <div class="flex">
        <div
          v-for="shippingMethod in shippingItem.shippingMethods"
          :key="shippingMethod.id"
          class="w-1/3 pt-2"
        >
          <label class="pr-5">
            <input
              type="radio"
              :value="shippingMethod.id"
              v-model="shippingMethods[shippingItem.sku.uuid]"
            />
            {{ shippingMethod.name }}
          </label>

          <div v-if="shippingCosts[shippingMethod.id]">
            <div v-if="shippingCosts[shippingMethod.id][shippingItem.sku.uuid]" >
              <div class="relative flex-1 flex flex-col justify-between">
                    <div class="pr-6 text-sm mt-2">
                        <div class="font-medium text-gray-700 hover:text-gray-800">
                          <!-- {{ $t('shop.shipping-cost') }}: -->
                          {{ formatPrice(getShippingCostInclVat(shippingMethod.id, shippingItem.sku.uuid) , shippingCosts[shippingMethod.id][shippingItem.sku.uuid].currency) }}
                        </div>
                    </div>
              </div>
            </div>  
          </div>

          <div v-if="!shippingCosts[shippingMethod.id]">
              <div class="font-medium text-gray-700 hover:text-gray-800 mt-2 text-red">
                Not available
              </div>
          </div>


        </div>
      </div>
    </div>

    <div
      class="
        mt-6
        sm:flex sm:items-center sm:justify-between
      "
    >
      <button
        @click="save()"
        type="submit"
        :disabled="false"
        class="block sm:flex sm:items-center px-4 py-3 rounded font-bold 
              text-sm cursor-pointer bg-green-500 text-white hover:bg-green-400
              text-center
              w-full sm:w-auto
              sm:order-last
        " >
        {{ $t("common.next") }}
      </button>

      <p class="mt-4 text-center text-sm text-gray-500 sm:mt-0 sm:text-left">
        {{ $t("shop.not-charget-yet") }}
      </p>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import number_format from '@/Utils/number_format';

export default {
  components: {
  },
  props: {
    shippingItems: Array,
    shippingCosts: Object,
  },
  data() {
    let shippingMethods = {};
    for(var i=0; i < this.shippingItems.length; i++){
      let shippingMethodId = this.shippingItems[i].shippingMethodId;
      let allowedSM = this.shippingItems[i].shippingMethods;
      shippingMethods[this.shippingItems[i].sku.uuid] = shippingMethodId || (allowedSM.length ? allowedSM[0].id : shippingMethodId);
    }

    return {
      processing: false,
      shippingMethods: shippingMethods,
    };
  },
  mounted(){
  },
  methods: {
    allowMultipleShipping(){
      return this.shippingItems.length > 1;
    },
    getShippingCostInclVat(shippingMethodId, skuId){
      if(typeof this.shippingCosts[shippingMethodId] === 'undefined'){
        return 0;
      }
      if(typeof this.shippingCosts[shippingMethodId][skuId] === 'undefined'){
        return 0;
      }
      let cost = parseFloat(this.shippingCosts[shippingMethodId][skuId].shipping_cost);
      return (cost * 0.01 * this.shippingCosts[shippingMethodId][skuId].shipping_vat) + cost ;
    },
    async save() {
      let data = this.shippingMethods;
      let url = "/shop/save-shipping-methods";

      await axios({
        method: "post",
        url: url,
        data: data,
      }).then(
        (response) => {
          //success
          let currentStep = this.$parent.step;
          this.$emit('step-change', response.data);
          let newStep = this.$parent.step;
          if(newStep !==currentStep){
            this.$toastr.s("", this.$t("common.data-saved"));
          }else{
            this.$toastr.e(this.$t("common.generic-error"), this.$t("common.save-error-title"));
          }
          
        },
        (error) => {
          if (typeof error.response !== "undefined") {
            if (error.response.data) {
              if (error.response.data.errors) {
                // component.errors = error.response.data.errors;
                console.error(error.response.data.errors)
              }

              if (error.response.data.message) {
                console.error(error.response.data.message);
              }
            }
          }
          this.$toastr.e(error.message, this.$t("common.save-error-title"));
        }
      );

      this.processing = false;
    },
    formatPrice(value, currency) {
        return number_format(parseFloat(value), 2) + ' ' + currency;
    }
  },
};
</script>
